var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus_indicator",
    "data-name": "bus indicator",
    transform: "translate(-52 -241.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40759",
    "data-name": "Path 40759",
    d: "M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(54 243.5)",
    fill: "#19bc9c",
    stroke: "#12997e",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "running_bus",
    "data-name": "running bus",
    transform: "translate(64.688 251.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M0,0H24V24H0Z",
    transform: "translate(-3.688 -2.438)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37169",
    "data-name": "Group 37169",
    transform: "translate(0.312 -0.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15923",
    "data-name": "Group 15923",
    transform: "translate(1.468 17.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_715",
    "data-name": "Line 715",
    d: "M.224,0H-.75V1.948H.224Z",
    transform: "translate(0.75 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_715-2",
    "data-name": "Line 715",
    d: "M.974,0H0V3.571H.974Z",
    transform: "translate(3.571 1.435) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_718",
    "data-name": "Line 718",
    d: "M.224,0H-.75V1.948H.224Z",
    transform: "translate(3.347 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36292",
    "data-name": "Group 36292",
    transform: "translate(9.66 17.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_715-3",
    "data-name": "Line 715",
    d: "M.224,0H-.75V1.948H.224Z",
    transform: "translate(0.75 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_715-4",
    "data-name": "Line 715",
    d: "M.974,0H0V3.571H.974Z",
    transform: "translate(3.571 1.435) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_718-2",
    "data-name": "Line 718",
    d: "M.224,0H-.75V1.948H.224Z",
    transform: "translate(3.347 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15922",
    "data-name": "Group 15922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3846",
    "data-name": "Rectangle 3846",
    d: "M2.362,1.206A1.2,1.2,0,0,0,1.181,2.411V16.076a1.2,1.2,0,0,0,1.181,1.206H13.387a1.2,1.2,0,0,0,1.181-1.206V2.411a1.2,1.2,0,0,0-1.181-1.206H2.362M2.362,0H13.387A2.387,2.387,0,0,1,15.75,2.411V16.076a2.387,2.387,0,0,1-2.363,2.411H2.362A2.387,2.387,0,0,1,0,16.076V2.411A2.387,2.387,0,0,1,2.362,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15921",
    "data-name": "Group 15921",
    transform: "translate(0.007 5.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15920",
    "data-name": "Group 15920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    d: "M1.181.862V6.609H14.57V.862H1.181M0,0H15.751V7.471H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_719",
    "data-name": "Line 719",
    d: "M.431,6.321H-.75V0H.431Z",
    transform: "translate(8.429 0.287)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15919",
    "data-name": "Group 15919",
    transform: "translate(2.579 9.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_853_-_Outline",
    "data-name": "Ellipse 853 - Outline",
    d: "M1.125,0A1.125,1.125,0,1,1,0,1.125,1.125,1.125,0,0,1,1.125,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_854_-_Outline",
    "data-name": "Ellipse 854 - Outline",
    d: "M1.125,0A1.125,1.125,0,1,1,0,1.125,1.125,1.125,0,0,1,1.125,0Z",
    transform: "translate(8.265)",
    fill: "#fff"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIndicator);
export default __webpack_public_path__ + "static/media/busIndicator.2ed9e44d3c44e1a51dac85eb0e041653.svg";
export { ForwardRef as ReactComponent };